module.exports = __webpack_public_path__ + "img/sticker_7.300e17b4.svg";